// extracted by mini-css-extract-plugin
export var afterFooter = "Footer-module--afterFooter--90c5e";
export var description = "Footer-module--description--9eb8b";
export var footer = "Footer-module--footer--85f4e";
export var groups = "Footer-module--groups--7acef";
export var groupsblock = "Footer-module--groupsblock--f0ee0";
export var inner = "Footer-module--inner--1a271";
export var link = "Footer-module--link--c1a94";
export var links = "Footer-module--links--aad6a";
export var logo = "Footer-module--logo--d26fe";
export var logostyle = "Footer-module--logostyle--0c294";
export var social = "Footer-module--social--99c70";
export var title = "Footer-module--title--3be37";
export var wrapper = "Footer-module--wrapper--2c347";